import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import "./calendar.scss";

import CalendarHeader from "./CalendarHeader";
import { useInitializeDays, useScreenWidth } from "../../shared/Helpers/hooks";
import MonthView from "./monthView";
import WeekView from "./weekView";
import CalendarPopups from "./Actions";

import { DispatchProperties, useSelector } from "../../redux/store";
import {
  clearFilterData,
  getEvents,
} from "../../redux/State/clientSlice/calendarSlice";
import { clearActiveTargets } from "../../redux/State/clientSlice/programTargetSlice";
import { getRoleConfigruation } from "../../redux/State/identitySlice/accountSlice";

const Calendar = () => {
  useInitializeDays();

  const dispatch = useDispatch<DispatchProperties>();
  const screenWidth = useScreenWidth();
  const [params] = useSearchParams();

  const includeBTEvents =
    params.get("includeBTEvents") === "true" ? true : false;
  const includeBCBAEvents =
    params.get("includeBCBAEvents") === "true" ? true : false;

  const view = useSelector((state) => state.calendar.calendarView);
  const filterData = useSelector((state) => state.calendar.filterData);
  const addEventOpen = useSelector((state) => state.calendar.popups.addAdmin);
  const days = useSelector((state) => state.calendar.displayedCalendarPageDays);

  useEffect(() => {
    dispatch(clearActiveTargets());
    dispatch(getRoleConfigruation());
    dispatch(clearFilterData());
  }, [dispatch]);

  useEffect(() => {
    if (!days.length || addEventOpen) return;

    const clientId = filterData.client?.id;
    const userId = filterData.therapist?.id;

    dispatch(getEvents({ days, clientId, userId, includeBTEvents, includeBCBAEvents }));
  }, [dispatch, filterData, days, includeBCBAEvents, includeBTEvents, addEventOpen]);

  return (
    <div className="container" style={{ flexDirection: "column" }}>
      <CalendarHeader />
      {view === 0 && <MonthView />}
      {(view === 1 || screenWidth < 426) && <WeekView />}
      <CalendarPopups />
    </div>
  );
};

export default Calendar;
